/* ============================================================
   tb-pdp-thumbs.js  -  TrendyBits  -  product page only
   ------------------------------------------------------------
   THE PROBLEM
   sections/tb-pdp.liquid renders EVERY product photo as a slide, but
   its thumbnail loop is capped:  {% for media in product.media limit: 5 %}
   So a product with 6+ photos had 6 slides and only 5 thumbnails, and
   nothing on the page hinted that more photos existed - the 6th was
   only reachable from the enlarged view.

   WHAT THIS DOES  (nothing in tb-pdp.liquid is modified)
   1. Creates the missing thumbnails from the slides the theme already
      rendered, matching the theme's own markup and 200px image width.
   2. Wraps the strip so it becomes one scrollable row with < > arrows
      and a fade on the right edge while there are more photos to see.
   3. Adds a "3 / 6" counter pill on the main image.
   4. Re-wires clicks. The theme's own handler captured its 5 buttons in
      a static NodeList inside an IIFE, so buttons added later are
      invisible to it. A delegated capture-phase listener on the strip
      handles every thumbnail, old and new, and keeps the counter and
      the active states in sync.

   The gallery has no JS state at all - the active photo is held purely
   by the .active class on .tb-pdp__slide - so this stays compatible
   with the theme handler and with the enlarge view.

   HOW TO REVERT
   Delete the script line for this file in snippets/meta-tags.liquid.
   ============================================================ */

(function () {
  'use strict';

  var VISIBLE_HINT = 0.8; // how far one arrow press scrolls, as a fraction of the strip

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function thumbUrl(raw) {
    try {
      var url = new URL(raw, window.location.href);
      url.searchParams.set('width', '200');
      return url.toString();
    } catch (e) {
      return raw;
    }
  }

  function makeNav(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tb-thumbs__nav tb-thumbs__nav--' + dir;
    b.setAttribute('aria-label', label);
    var points = dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    b.innerHTML =
      "<svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' " +
      "stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'>" +
      "<polyline points='" + points + "'></polyline></svg>";
    return b;
  }

  ready(function () {
    var media = document.querySelector('.tb-pdp__media');
    if (!media) return;

    var slidesBox = media.querySelector('.tb-pdp__slides');
    var strip = media.querySelector('.tb-pdp__thumbs');
    if (!slidesBox || !strip) return;

    var slides = slidesBox.querySelectorAll('.tb-pdp__slide');
    if (slides.length < 2) return;

    /* ---- 1. build the thumbnails the limit: 5 left out ---- */
    var existing = strip.querySelectorAll('.tb-pdp__thumb');
    var model = existing.length ? existing[existing.length - 1] : null;

    for (var i = existing.length; i < slides.length; i++) {
      var source = slides[i].querySelector('img');
      if (!source) continue; // video / 3D media has no still to copy

      var btn;
      if (model) {
        btn = model.cloneNode(true);
      } else {
        btn = document.createElement('button');
        btn.className = 'tb-pdp__thumb';
        btn.appendChild(document.createElement('img'));
      }
      btn.type = 'button';
      btn.classList.remove('active');
      btn.setAttribute('data-thumb-index', String(i));
      btn.setAttribute('data-tb-extra', '1');
      btn.setAttribute('aria-label', 'Show media ' + (i + 1));

      var img = btn.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.setAttribute('loading', 'lazy');
        img.src = thumbUrl(source.getAttribute('src') || source.src);
        img.alt = source.alt || '';
      }
      strip.appendChild(btn);
    }

    var thumbs = strip.querySelectorAll('.tb-pdp__thumb');

    /* ---- 2. wrap the strip, add arrows ---- */
    var wrap = document.createElement('div');
    wrap.className = 'tb-thumbs';
    strip.parentNode.insertBefore(wrap, strip);
    wrap.appendChild(strip);

    var prev = makeNav('prev', 'Previous photos');
    var next = makeNav('next', 'More photos');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    /* ---- 3. counter pill on the main image ---- */
    var counter = null;
    var slider = media.querySelector('.tb-pdp__main-slider');
    if (slider) {
      counter = document.createElement('div');
      counter.className = 'tb-gal-count';
      counter.innerHTML = '<span data-tb-cur>1</span> / ' + slides.length;
      slider.appendChild(counter);
    }

    /* ---- 4. selection, kept in the DOM exactly like the theme does ---- */
    function activeIndex() {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].classList.contains('active')) return n;
      }
      return 0;
    }

    function paintCounter(i) {
      if (!counter) return;
      var cur = counter.querySelector('[data-tb-cur]');
      if (cur) cur.textContent = String(i + 1);
    }

    function reveal(i) {
      var t = thumbs[i];
      if (!t) return;
      var left = t.offsetLeft;
      var right = left + t.offsetWidth;
      if (left < strip.scrollLeft) {
        strip.scrollLeft = Math.max(0, left - 4);
      } else if (right > strip.scrollLeft + strip.clientWidth) {
        strip.scrollLeft = right - strip.clientWidth + 4;
      }
    }

    function select(i) {
      for (var n = 0; n < slides.length; n++) {
        slides[n].classList.toggle('active', n === i);
      }
      for (var m = 0; m < thumbs.length; m++) {
        thumbs[m].classList.toggle('active', m === i);
      }
      paintCounter(i);
      reveal(i);
    }

    strip.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('.tb-pdp__thumb') : null;
      if (!t) return;
      var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
      if (isNaN(idx)) return;
      select(idx);
    }, true);

    /* Anything else that changes the photo (variant switch, enlarge view)
       only touches the .active class, so mirror it back into the strip. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var i = activeIndex();
        for (var m = 0; m < thumbs.length; m++) {
          thumbs[m].classList.toggle('active', m === i);
        }
        paintCounter(i);
      }).observe(slidesBox, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    /* ---- 5. arrow behaviour and scroll state ---- */
    function sync() {
      var max = strip.scrollWidth - strip.clientWidth;
      wrap.classList.toggle('is-scrollable', max > 2);
      prev.disabled = strip.scrollLeft <= 1;
      next.disabled = strip.scrollLeft >= max - 1;
      wrap.classList.toggle('at-start', prev.disabled);
      wrap.classList.toggle('at-end', next.disabled);
    }

    function page(dir) {
      var step = Math.max(80, Math.round(strip.clientWidth * VISIBLE_HINT));
      if (strip.scrollBy) strip.scrollBy({ left: dir * step, behavior: 'smooth' });
      else strip.scrollLeft += dir * step;
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sync();
    setTimeout(sync, 300);
    window.addEventListener('load', sync);
  });
})();
